import { z } from 'zod';
import { bindInputMaker } from '../util.make-input.js';

const makeInput = bindInputMaker();
const hyphenatableWordInput = makeInput({
  entry: {
    schema: z.object({
      type: z.literal("hyphenatable-word").default("hyphenatable-word"),
      hyphenation: z.array(z.string()).default([])
    }),
    shouldValidate: node => node.meta.hyphenatable,
    validate: (node, entry) => {
      let remaingAllowedHyphenations = node.validation.allowedHyphenations.filter(it => it.length === entry.hyphenation.length);
      if (!remaingAllowedHyphenations.length) {
        return false;
      }
      for (let i = 0; i < entry.hyphenation.length; i++) {
        const entrySegment = entry.hyphenation[i];
        if (!entrySegment) {
          return false;
        }
        remaingAllowedHyphenations = remaingAllowedHyphenations.filter(allowedHyphenation => {
          const allowedSegment = allowedHyphenation[i];
          return entrySegment === allowedSegment;
        });
      }
      return remaingAllowedHyphenations.length > 0;
    },
    parseLegacyDetailItem: (item, context) => {
      if (["SelectAnswers"].includes(context.relatedTask.taskType) && ["HyphenateWords"].includes(context.relatedTask.answerType ?? "") && Array.isArray(item) && typeof item[0] === "string") {
        return [context.relatedInput?.id ?? `${context.relatedTask.id}-${context.indexInDetails}`, {
          type: "hyphenatable-word",
          hyphenation: item
        }];
      }
    }
  },
  schema: z.object({
    text: z.string(),
    hyphenated: z.boolean(),
    correctAnswer: z.array(z.array(z.string())).default([])
  }),
  postprocessSchemaInput: ({
    correctAnswer,
    hyphenated,
    ...input
  }, context) => {
    return {
      ...input,
      id: `${context.taskId}-${context.index}`,
      nodeType: "hyphenatable-word-input",
      meta: {
        hyphenatable: hyphenated
      },
      validation: {
        allowedHyphenations: correctAnswer
      }
    };
  }
});

export { hyphenatableWordInput };
//# sourceMappingURL=input.hyphenatable-word.js.map
